module.exports = __webpack_public_path__ + "static/media/GoogleSans-Bold.4457817a.ttf";